import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 116 125"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M53.21 16.208a4.625 4.625 0 0 1 4.625 4.625v49.334h49.333a4.626 4.626 0 0 1 4.582 3.995l.043.63c0 30.648-24.852 52.416-55.5 52.416a55.5 55.5 0 0 1-55.5-55.5c0-30.648 21.768-55.5 52.417-55.5M71.71.792a55.5 55.5 0 0 1 55.5 55.5 4.627 4.627 0 0 1-4.625 4.624H71.71a4.625 4.625 0 0 1-4.625-4.624V5.416A4.625 4.625 0 0 1 71.71.791"
    }, null, -1)
  ])))
}
export default { render: render }